"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = exports.MIN_NUMBER_ROWS = void 0;
var tslib_1 = require("tslib");
var hyperscript_1 = tslib_1.__importDefault(require("mithril/hyperscript"));
var i18n_1 = require("../../i18n");
var key_binding_1 = require("../../services/util/key.binding");
var classnames_1 = require("../../util/classnames");
var theme_1 = require("../theme");
var input_style_1 = require("./input.style");
exports.MIN_NUMBER_ROWS = 1;
(0, theme_1.addStyles)(input_style_1.Style);
function addStateClasses(state, classList) {
    if (classList === void 0) { classList = []; }
    if (state.focused) {
        classList.push(input_style_1.CSS.isFocused);
        classList.push(input_style_1.CSS.MDL.isFocused);
    }
    if (state.isFilled) {
        classList.push(input_style_1.CSS.isDirty);
        classList.push(input_style_1.CSS.MDL.isDirty);
    }
    if (state.touched && !state.isValid) {
        classList.push(input_style_1.CSS.isInvalid);
        classList.push(input_style_1.CSS.MDL.isInvalid);
    }
    if (state.isLabelShown === false) {
        classList.push(input_style_1.CSS.isCompact);
    }
    return classList;
}
var FOCUS_NODE = function (vnode) {
    vnode.dom.focus();
};
exports.Input = {
    CSS: input_style_1.CSS,
    view: function (state, ctx) {
        var _this = this;
        var _a;
        if (ctx === void 0) { ctx = {}; }
        var classList = [
            input_style_1.CSS.container,
            input_style_1.CSS.MDL.container,
            "".concat(input_style_1.CSS.container, "--").concat(state.id),
            "".concat(input_style_1.CSS.container, "--").concat(state.label.toLowerCase())
        ];
        var className = addStateClasses(state, classList).join(' ');
        var onChange = function (e) { return exports.Input.onChange(state, e); };
        var onKeyUp = function (e) { return exports.Input.onKeyUp(state, e); };
        var onInput = function (e) { return exports.Input.onInput(state, e); };
        var attrs = {
            className: ctx.rawInputOnly ? '' : (0, classnames_1.classNames)(input_style_1.CSS.input, input_style_1.CSS.MDL.input),
            name: state.name,
            oninput: onInput,
            onchange: onChange,
            value: state.inputValue != null ? state.inputValue : '',
            title: state.hasError() ? (0, i18n_1.Translate)(state.error) : undefined,
            onfocus: function (e) { return exports.Input.onFocus(state); },
            onblur: function (e) { return exports.Input.onBlur(state, e); },
            oncreate: state.isAutoFocused ? FOCUS_NODE : state.focused ? FOCUS_NODE : undefined,
            onupdate: state.selected ? (function (vnode) { return _this.onSelected(vnode, state); }) : null,
            onkeyup: onKeyUp
        };
        // create textAreas when rows are defined
        var isTextArea = Boolean(ctx.rows);
        if (isTextArea) {
            attrs.rows = ctx.rows;
            attrs.style = { resize: 'none', overflow: 'hidden', outline: 'none' };
        }
        else {
            attrs.type = (_a = ctx.type) !== null && _a !== void 0 ? _a : state.type;
        }
        if (state.disabled) {
            attrs.disabled = true;
        }
        if (state.readOnly) {
            attrs.readOnly = true;
        }
        if (state.placeholder != null) {
            attrs.placeholder = state.placeholder;
        }
        if (ctx.rawInputOnly) {
            return (0, hyperscript_1.default)(isTextArea ? 'textarea' : 'input', attrs);
        }
        var children = [
            (0, hyperscript_1.default)(isTextArea ? 'textarea' : 'input', attrs)
        ];
        var labelText = state.isLabelShown ? (0, i18n_1.Translate)(state.label) : '';
        children.push((0, hyperscript_1.default)('label', { className: input_style_1.CSS.label + ' ' + input_style_1.CSS.MDL.label }, labelText));
        if (state.touched && state.isErrorShown) {
            if (state.hasError()) {
                children.push((0, hyperscript_1.default)('span', { className: input_style_1.CSS.MDL.error + ' ' + input_style_1.CSS.error }, (0, i18n_1.Translate)(state.error)));
            }
            else if (state.isRequired && !state.isFilled) {
                children.push((0, hyperscript_1.default)('span', { className: input_style_1.CSS.MDL.error + ' ' + input_style_1.CSS.error }, (0, i18n_1.Translate)(i18n_1.T.INPUT_REQUIRED)));
            }
        }
        return (0, hyperscript_1.default)('div', { className: className, 'data-state-id': state.id }, children);
    },
    onSelected: function (vnode, state) {
        vnode.dom.select();
        state.setSelected(false);
    },
    onKeyUp: function (state, e) {
        var ev = e;
        if (ev.keyCode === key_binding_1.KeyCode.ENTER &&
            ev.shiftKey &&
            e.target instanceof HTMLInputElement &&
            state.focused) {
            this.onInput(state, e, true);
        }
    },
    onChange: function (state, e) {
        var target = e.target;
        state.setInputValue(target.value);
    },
    onInput: function (state, e, enter) {
        state.onInput(e);
        var target = e.target;
        if (enter) {
            state.setInputValue(target.value.concat('\n'));
        }
        else {
            state.setInputValue(target.value);
        }
    },
    onFocus: function (state) {
        state.setFocused(true);
    },
    onBlur: function (state, e) {
        state.onBlur(e);
        state.setFocused(false);
        state.setTouched();
    }
};
//# sourceMappingURL=input.js.map